import CustomCarousel from 'general/components/quybka/Others/CustomCarousel';
import AppColors from 'general/constants/AppColors';
import AppResource from 'general/constants/AppResource';
import UIHelper from 'general/helpers/UIHelper';
import PropTypes from 'prop-types';

AgencyDashboardHeaderView.propTypes = {
  name: PropTypes.string,
  role: PropTypes.string,
  contentEl: PropTypes.element,
  showSlide: PropTypes.bool,
  replaceContentEl: PropTypes.element,
};

function AgencyDashboardHeaderView({ name, role, contentEl, showSlide = true, replaceContentEl }) {
  return (
    <div>
      {
        showSlide
          ? (
            <div>
              {UIHelper.buildCard(
                <div className="row m-0 p-0">
                  <div className="col-lg-5 p-0">
                    <div
                      className="d-flex flex-column p-4"
                      style={{
                        borderBottom: `1px solid ${AppColors.gray[200]}`,
                      }}
                    >
                      <span style={UIHelper.buildFontStyle('700', '30px', AppColors.gray[600])}>
                        {name}
                      </span>
                      <span style={UIHelper.buildFontStyle('700', '26px', AppColors.primary)}>{role}</span>
                    </div>

                    <div className="d-flex flex-column gap-3 pt-2 pb-6">{contentEl}</div>
                  </div>
                  {/* carousel */}
                  <div className="col-lg-7 p-0">
                    <CustomCarousel
                      images={[
                        { src: AppResource.images.evg.imgSlide1, alt: 'Image 1' },
                        { src: AppResource.images.evg.imgSlide2, alt: 'Image 2' },
                        { src: AppResource.images.evg.imgSlide3, alt: 'Image 3' },
                      ]}
                      interval={5000}
                    />
                  </div>
                </div>
              )}
            </div>
          )
          : (
            <div className="row m-0 p-0">
              <div className="col-lg-6 p-0 pr-2">
                {UIHelper.buildCard(
                  <div>
                    <div
                      className="d-flex flex-column p-4"
                      style={{
                        borderBottom: `1px solid ${AppColors.gray[200]}`,
                      }}
                    >
                      <span style={UIHelper.buildFontStyle('700', '30px', AppColors.gray[600])}>
                        {name}
                      </span>
                      <span style={UIHelper.buildFontStyle('700', '26px', AppColors.primary)}>{role}</span>
                    </div>

                    <div className="d-flex flex-column gap-3 pt-2 pb-6">{contentEl}</div>
                  </div>
                )}
              </div>
              <div className="col-lg-6 p-0 pl-2">
                {replaceContentEl}
              </div>
            </div>
          )
      }
    </div>
  );
}

export default AgencyDashboardHeaderView;
